import { cacheDom } from "../utils/QuerySelectors.js"

const dom = {}
const qs = {
  section: 'data-section-type="contact-form"',
}
const qsAll = {
  reasons: 'data-contact-reason',
}

export const setupContactForm = () => {
  cacheDom(dom, qs, qsAll)
  if(dom.section) {
    let timer = setInterval(() => {
      const reasons = document.querySelectorAll(`[${qsAll.reasons}]`)
      if(reasons.length > 0) {
        reasons.forEach(reason => {
          const id = reason.dataset.contactReason
          if(typeof id != 'undefined' && id && document.querySelector(`#${id}`)) {
            reason.innerHTML = `
              <div class="flex items-center justify-between text-black text-xs leading-none !mb-4">
                Frequently Asked Questions
                <div class="flex items-center">
                  See all&nbsp;
                  <a class="cta-link--accent !text-xs" href="/pages/faq#${id}" target="_blank" style="font-family: Frankfurter, serif !important;">
                    FAQ
                  </a>
                </div>
              </div>
              <div class="contact-reason-faq--accordion">
                ${document.querySelector(`#${id}`).innerHTML}
              </div>
            `
          }
        })
        const details = document.querySelectorAll(`[${qsAll.reasons}] details`)
        details.forEach(detail => {
          detail.style.height = ''
          detail.removeAttribute('data-accordion-details')
          detail.querySelector('summary').removeAttribute('data-accordion-summary')
        })
        clearInterval(timer)
      }
    }, 500)
  }
}